<template>
  <div class="exempt-write-modify" v-loading="loading">
    <el-form ref="form" label-width="200px">
      <el-form-item label="审核失败原因：">
        <el-input type="textarea" :maxlength="200" :disabled="true" v-model="noPassReason"></el-input>
      </el-form-item>
      <el-form-item label="免笔试申请条件：" v-if="exemptWriteTypeList && exemptWriteTypeList.length">
        <el-radio-group v-model="exemptWriteType" @change="changeExemptWriteType" :disabled="!canEdit">
          <template v-for="(item, index) in exemptWriteTypeList">
            <el-radio class="margin-top" v-if="item && item.code && item.name && item.code !== '0'" :label="item.code" :key="index">{{item.name}}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="exemptWriteImageListTitle" v-if="exemptWriteType && exemptWriteType !== '0'">
        <div class="exempt-write-image-list">
          <multi-upload  v-model="exemptWriteImageList" :limit="-1" title="" :disabled="!canEdit" :showInVerify="true"></multi-upload>
        </div>
      </el-form-item>
      <el-form-item :label="exemptWriteImageOneListTitle" v-if="exemptWriteType && exemptWriteType !== '0' && exemptWriteType !== '4'">
        <div class="exempt-write-image-list">
          <multi-upload  v-model="exemptWrite1ImageList" :limit="-1" title="" :disabled="!canEdit" :showInVerify="true"></multi-upload>
        </div>
      </el-form-item>
      <el-form-item :label="exemptWriteFileTwoPathTitle" v-if="exemptWriteType === '1'">
        <div class="exempt-write-image-list">
          <multi-upload v-model="exemptWrite2ImageList" :limit="-1" title="" :disabled="!canEdit" :showInVerify="true" upload-type="pdf"></multi-upload>
        </div>
      </el-form-item>
    </el-form>
    <div class="bottom-box">
      <div class="verify-success" @click.stop="submitEditor" v-if="canEdit">修改提交</div>
      <div class="verify-success verify-fail" @click.stop="closePop">关闭</div>
    </div>
  </div>
</template>

<script>
import multiUpload from './multiUpload'
export default {
  name: 'ExemptWriteModify',
  components: {
    multiUpload
  },
  props: {
    rowData: Object,
    visible: ''
  },
  computed: {
    exemptWriteImageListTitle () {
      if (this.exemptWriteType === '1') {
        return '副高证书照片'
      } else if (this.exemptWriteType === '2') {
        return '硕士毕业证书信息页照片'
      } else if (this.exemptWriteType === '3') {
        return '国考准考证照片'
      } else if (this.exemptWriteType === '4') {
        return '立功受奖证书信息页或专业技术职务资格证书照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteImageOneListTitle () {
      if (this.exemptWriteType === '1') {
        return '最后学历照片'
      } else if (this.exemptWriteType === '2') {
        return '硕士学位证书信息页照片'
      } else if (this.exemptWriteType === '3') {
        return '国考成绩照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileTwoPathTitle () {
      if (this.exemptWriteType === '1') {
        return '单位证明'
      } else {
        return '免考材料'
      }
    },
    disableNow () {
      return this.disabled || !this.editorNow
    }
  },
  data () {
    return {
      loading: false,
      exemptWriteType: '',
      exemptWriteTypeList: [],
      exemptWriteImageList: [],
      exemptWrite1ImageList: [],
      exemptWrite2ImageList: [],
      noPassReason: '',
      canEdit: false
    }
  },
  methods: {
    closePop () {
      this.$emit('hidePopoverAndRefresh')
    },
    submitEditor () {
      let imageForm = {}
      if (this.loading) {
        return false
      }
      this.loading = true
      if (!this.rowData || !this.rowData.id) {
        this.loading = false
        this.$message.error('获取学生id失败,请联系管理员')
        return false
      } else if (!this.exemptWriteType) {
        this.loading = false
        this.$message.error('未知的免考类型')
        return false
      } else {
        // 校验图片数量
        if (this.exemptWriteType !== '0' && (!this.exemptWriteImageList || !this.exemptWriteImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteImageListTitle + '缺失')
          return false
        } else if ((this.exemptWriteType === '1' || this.exemptWriteType === '2' || this.exemptWriteType === '3') && (!this.exemptWrite1ImageList || !this.exemptWrite1ImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteImageOneListTitle + '缺失')
          return false
        } else if (this.exemptWriteType === '1' && (!this.exemptWrite2ImageList || !this.exemptWrite2ImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteFileTwoPathTitle + '缺失')
          return false
        }
        imageForm.exemptWriteFilePath = this.exemptWriteImageList && this.exemptWriteImageList.length ? this.exemptWriteImageList.join(',') : ''
        imageForm.exemptWriteFilePath1 = this.exemptWrite1ImageList && this.exemptWrite1ImageList.length ? this.exemptWrite1ImageList.join(',') : ''
        imageForm.exemptWriteFilePath2 = this.exemptWrite2ImageList && this.exemptWrite2ImageList.length ? this.exemptWrite2ImageList.join(',') : ''
      }
      this.$ajax({
        url: `${this.$attrs['extra-params'].url}/updateEnrollData`,
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id,
          exemptWriteType: this.exemptWriteType,
          ...imageForm
        })
      }).then((res) => {
        if (res && res.data && res.data.errorCode === 0) {
          this.loading = false
          this.$message.success('免考信息修改成功')
          this.closePop()
        } else {
          let msg = res && res.data && res.data.message ? res.data.message : '免考信息修改失败'
          this.$message.error(msg)
        }
      }).catch(() => {
        this.$message.error('免考信息修改失败')
      }).finally(() => {
        this.loading = false
      })
    },
    changeExemptWriteType (code) {
      this.exemptWriteImageList = []
      this.exemptWrite1ImageList = []
      this.exemptWrite2ImageList = []
    },
    initData () {
      if (this.loading) {
        return false
      }
      this.loading = true
      if (!this.rowData || !this.rowData.id) {
        this.loading = false
        this.$message.error('获取学生id失败,请联系管理员')
      } else {
        this.$ajax({
          url: `${this.$attrs['extra-params'].url}/queryEnrollData`,
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.rowData.id
          })
        }).then((res) => {
          if (res && res.data && res.data.errorCode === 0) {
            this.canEdit = res.data.canEdit
            this.exemptWriteType = res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteType ? res.data.enrollBasicInfo.exemptWriteType : ''
            this.exemptWriteTypeList = res.data.exemptWriteTypeList && res.data.exemptWriteTypeList.length ? res.data.exemptWriteTypeList : []
            this.noPassReason = res.data.enrollBasicInfo && res.data.enrollBasicInfo.noPassReason ? res.data.enrollBasicInfo.noPassReason : ''
            this.$nextTick(() => {
              setTimeout(() => {
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath && res.data.enrollBasicInfo.exemptWriteFilePath.length) {
                  this.exemptWriteImageList = res.data.enrollBasicInfo.exemptWriteFilePath.split(',')
                } else {
                  this.exemptWriteImageList = []
                }
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath1 && res.data.enrollBasicInfo.exemptWriteFilePath1.length) {
                  this.exemptWrite1ImageList = res.data.enrollBasicInfo.exemptWriteFilePath1.split(',')
                } else {
                  this.exemptWrite1ImageList = []
                }
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath2 && res.data.enrollBasicInfo.exemptWriteFilePath2.length) {
                  this.exemptWrite2ImageList = res.data.enrollBasicInfo.exemptWriteFilePath2.split(',')
                } else {
                  this.exemptWrite2ImageList = []
                }
              })
            }, 100)
            this.$forceUpdate()
          } else {
            this.$message.error('获取学生id失败,请联系管理员')
          }
        }).catch(() => {
          this.$message.error('获取学生id失败,请联系管理员')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.initData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exempt-write-modify{
  padding: 40px 20px 20px 20px;
  background: #FFFFFF;
  min-width: 600px;
  position: relative;
  .margin-top{
    margin-top: 1px;
  }
  ::v-deep .el-form-item__label{
    margin-top: 1px;
  }
  .exempt-write-image-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .bottom-box{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    .verify-success{
      padding: 10px 0px;
      width: 100px;
      box-sizing: border-box;
      background: rgba(13, 89, 167, 1);
      color: #FFFFFF;
      border-radius: 10px;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
    }
    .verify-fail{
      margin-left: 20px;
    }
  }
  .title-tips{
    position: absolute;
    right: 50px;
    display: flex;
    align-items: center;
    top: 15px;
    .editor{
      cursor: pointer;
      text-decoration: underline;
      color: rgb(13, 89, 167);
    }
    .close{
      margin-left: 20px;
    }
  }
}
</style>
